import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import { WelcomeFlows } from "../types";

const FLOW_SEARCH_PARAM = "flow";

export const useFlow = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setFlow = useCallback(
    (flow: keyof typeof WelcomeFlows) => {
      const newSearchParams = new URLSearchParams();
      newSearchParams.set(FLOW_SEARCH_PARAM, flow);
      setSearchParams(newSearchParams);
    },
    [setSearchParams]
  );

  return [searchParams.get(FLOW_SEARCH_PARAM), setFlow] as const;
};
